import { styled } from "@mui/material"

const DataGridContainer = styled("div")(() => ({
    width: "100%",
}))

export { DataGridContainer }
